import React from 'react';
import { CheckCircle, XCircle, RotateCcw } from 'lucide-react';
import './ClientUploadResults.css';

const StatusIcon = ({ status }) => {
  if (status === 'done') return <CheckCircle size={22} className="cur-icon cur-icon-ok" aria-label="Uploaded" />;
  if (status === 'failed') return <XCircle size={22} className="cur-icon cur-icon-fail" aria-label="Not uploaded" />;
  return <span className="spinner cur-spinner" aria-label="Uploading" />;
};

export const ClientUploadResults = ({ items, busy, onRetry, onBack, onReset }) => {
  const done = items.filter(i => i.status === 'done').length;
  const failed = items.filter(i => i.status === 'failed').length;
  const canRetry = items.some(i => i.status === 'failed' && i.retryable);
  const allDone = !busy && done === items.length;

  return (
    <div className="client-upload-results" data-testid="client-upload-results">
      {allDone ? (
        <div className="cur-summary" data-testid="client-upload-summary">
          <CheckCircle size={56} className="success-icon" />
          <h3>{items.length === 1 ? 'Document Uploaded Successfully' : `All ${items.length} documents uploaded`}</h3>
          <p>Thank you. Your documents have been received.</p>
        </div>
      ) : (
        <div className="cur-summary" data-testid="client-upload-summary">
          <h3>{busy ? 'Uploading your documents...' : `${done} of ${items.length} documents uploaded`}</h3>
          {!busy && failed > 0 && (
            <p>
              The files in red did not upload.
              {done > 0 && ' The others are saved and do not need to be sent again.'}
            </p>
          )}
        </div>
      )}

      <ul className="cur-list">
        {items.map((item, idx) => (
          <li key={item.key} className={`cur-item cur-${item.status}`} data-testid={`client-upload-result-${idx}`} data-status={item.status}>
            <StatusIcon status={item.status} />
            <div className="cur-text">
              <span className="cur-name" data-testid={`client-upload-result-name-${idx}`}>{item.file.name}</span>
              {item.status === 'failed' && (
                <span className="cur-reason" data-testid={`client-upload-result-reason-${idx}`}>{item.reason}</span>
              )}
            </div>
          </li>
        ))}
      </ul>

      {!busy && failed > 0 && (
        <div className="cur-actions">
          {canRetry && (
            <button type="button" className="btn-submit" onClick={onRetry} data-testid="client-upload-retry-failed">
              <RotateCcw size={18} />
              Try the files in red again
            </button>
          )}
          <button type="button" className="cur-link-btn" onClick={onBack} data-testid="client-upload-back-to-form">
            Back to the form to choose different files
          </button>
        </div>
      )}
      {allDone && (
        <div className="cur-actions">
          <button type="button" className="cur-link-btn" onClick={onReset} data-testid="client-upload-another">
            Upload more documents
          </button>
        </div>
      )}
    </div>
  );
};
